import axiosInstance, { endpoints } from 'src/utils/axios';

import { createArrayHook, createResourceActions } from './utils/create-action';

// ----------------------------------------------------------------------

const endpoint = endpoints.paycard.employees;

// Custom actions for paycard employee management
const customEmployeeActions = {
    // History hooks using createArrayHook
    getPaymentHistory: (id, args) => {
        const url = id ? `${endpoint.list}/${id}/payment-history` : null;
        return createArrayHook(url)(args);
    },
    getRegistrationHistory: (id, args) => {
        const url = id ? `${endpoint.list}/${id}/registration-history` : null;
        return createArrayHook(url)(args);
    },

    // Payment assignment
    assignPaymentToEmployee: (args) => {
        const url = endpoint.assignPayments(args.id);
        const { paymentsIds } = args;
        return axiosInstance.post(url, { paymentsIds });
    },

    // Employee opt-out
    optOutEmployee: (args) => {
        const url = endpoint.optOut(args.id);
        return axiosInstance.post(url);
    },

    // Account management
    editPaycardAccount: (args) => {
        const url = endpoint.editAccount(args.id);
        const { accountNumber, service } = args;
        return axiosInstance.post(url, { accountNumber, service });
    },

    checkPaycardAccountNumberStatus: (args) => {
        const url = endpoint.checkAccountNumberStatus;
        const { storeId, accountNumber } = args;
        return axiosInstance.post(url, { storeId, accountNumber });
    },

    checkPaycardAccountStatus: (args) => {
        const url = endpoint.checkAccountStatus(args.id);
        return axiosInstance.get(url);
    },

    registerPaycardAccount: (args) => {
        const url = endpoint.registerAccount(args.id);
        const { accountNumber, service } = args;
        return axiosInstance.post(url, { accountNumber, service });
    }
};

// Create all employee actions using factory
const {
    list: useGetPaycardEmployees,
    get: useGetEmployee,
    create: createPaycardEmployee,
    update: updatePaycardEmployee,
    delete: onDelete,
    bulkDelete: bulkDeletePaycardEmployees,
    count: useCountPaycardEmployees,
    ...customActions
} = createResourceActions(endpoint.list, {
    customActions: customEmployeeActions
});

// Export CRUD actions
export {
    onDelete,
    useGetEmployee,
    createPaycardEmployee,
    updatePaycardEmployee,
    useGetPaycardEmployees,
    useCountPaycardEmployees,
    bulkDeletePaycardEmployees
};

// Export custom actions with proper names
export const useGetEmployeePaymentHistory = customActions.getPaymentHistory;
export const useGetEmployeeRegistrationHistory = customActions.getRegistrationHistory;
export const { assignPaymentToEmployee } = customActions;
export const { checkPaycardAccountNumberStatus } = customActions;
export const { checkPaycardAccountStatus } = customActions;
export const { editPaycardAccount } = customActions;
export const { optOutEmployee } = customActions;
export const { registerPaycardAccount } = customActions;